module.exports = __webpack_public_path__ + "img/20191014165717813.53afff4e.jpg";